<template>
    <div v-click-outside="closeDropdown" class="u-pos-relative c-customer-search" :class="{'is-open' : open}">

        <v-input v-model="search"
                 autocomplete="off"
                 custom-label-class="u-flex--no-shrink"
                 type="search"
                 custom-class="c-product-search__input"
                 :aria-expanded="`${open ? 'true' : 'false'}`"
                 :fluid="true"
                 :horizontal="true"
                 :name="`${_uid}-product-search`"
                 :placeholder="placeholder"
                 @input="getSuggestions"
                 @focus="openDropdown"
                 @enter="navigateToSearch">

            <slot v-if="showLabel" slot="label">
                <slot name="labelText"><span v-html="$t('preorder_fiche.search_products')"></span></slot>
            </slot>

            <slot v-if="type === 'global'" slot="suffix">
                <router-link :to="{ name: 'ShopOverview', query: { 'search': search, 'addBranchFilter': false } }"
                             class="c-button c-button--small"
                             title="Zoeken">
                    <svgicon name="search"></svgicon>
                </router-link>
            </slot>

            <slot slot="dropdown">
                <transition name="loading">
                    <v-loader class="c-product-search__loader" :class="{'is-visible': loading}" v-show="loading" type="circle" size="small"></v-loader>
                </transition>

                <!--<input type="search" v-model="search" @focus="openDropdown">-->
                <div :class="{ 'c-product-search-dropdown': true, 'no-group': !canAddGroup}" v-if="open">
                    <div v-if="ProductSuggestions.length === 0 && !loading"
                         class="u-font-medium u-text-align-center u-padding">{{ $t('global.no_results') }}
                    </div>
                    <ul class="c-product-search-results-list" role="listbox" aria-autocomplete="both">

                        <!-- Product groups -->
                        <li v-for="item in ProductSuggestions" :key="item.Id"
                            class="c-product-search-line--group c-product-search-line"
                            :class="[item.Products.length > 1 ? 'has-variants' : '', {'is-selected': item.IsSelected}]">

                            <div class="c-product-search__item c-product-search__item--group">
                                <span :title="`${item.ErpId} - ${item.Name}`" class="c-product-search-item__name">{{item.ErpId}} - {{item.Name}}</span>
                                <v-product-search-add v-if="canAddGroup"
                                                      @change="$emit('add-group-to-sheet', item.Id)"
                                                      name="item"
                                                      :item.sync="item"
                                                      color="alpha">
                                </v-product-search-add>
                            </div>

                            <!-- Product variants inside product group -->
                            <ul class="c-product-search-variants-list" v-if="item.Products.length > 1 || !canAddGroup">

                                <li @click="variantClick" v-for="child in item.Products" :key="child.Id" :class="{'is-selected': child.IsSelected}">
                                    <div @click="!canAddGroup ? $emit('add-product-to-sheet', child.Id, item.Id, child.Id) : null"
                                         class="c-product-search__item c-product-search__item--variant">

                                        <span :title="`${item.ErpId} - ${item.Name}`" class="c-product-search-item__name">{{child.ColorId}} {{child.Color}}</span>
                                        <v-product-search-add v-if="showAddButton" @change="canAddGroup ? $emit('add-product-to-sheet', child.Id, item.Id, child.Color): null"
                                                              name="child" :item.sync="child"
                                                              color="neutral"
                                                              :icon-svg-name="iconSvgName">
                                        </v-product-search-add>
                                    </div>
                                </li>

                            </ul>
                        </li>

                    </ul>
                </div>
            </slot>
        </v-input>
    </div>
</template>

<script>
    import Vue from 'vue'
    import VInput from '@/components/form/Input'
    import VProductSearchAdd from './widgets/Add'
    import vClickOutside from 'v-click-outside';
    import VLoader from '@/components/loader/Loader';
    import _ from 'lodash'

    // Register outside Click plugin
    Vue.use(vClickOutside);

    export default {
        props: {
            placeholder: String,
            options: Array,
            marketingOnly: {type: Boolean, default: null},
            includePreOrderProducts: {type: Boolean, default: false},
            canAddGroup: {type: Boolean, default: true},
            iconSvgName: String,
            showLabel: {type: Boolean, default: true},
            showAddButton: {type: Boolean, default: true},
            closeOnClick: {type: Boolean, default: false},
            type: { type: String, default: 'default' },
            preorderSheetId: { type: String, default: null },
            addBranchFilter: {type: Boolean, default:false},
            branchRestriction: {type: String, default: null}
        },
        components: {
            VProductSearchAdd,
            VInput,
            VLoader,
        },
        data() {
            return {
                localOptions: this.options,
                focus: false,
                loading: false,
                close: false,
                search: '',
                suggestions: []
            }
        },
        computed: {
            open: {
                get() {
                    if (String(this.search).length >= 3 && this.focus && !this.close) {
                        return true;
                    } else {
                        return false;
                    }
                },
                set(value) {
                    return value;
                }
            },
            ProductSuggestions() {
                return this.suggestions;
            }
        },
        methods: {
            openDropdown() {
                this.getSuggestions();
                this.focus = true;
                this.close = false;
            },
            closeDropdown() {
                this.suggestions = [];
                this.close = true;
            },
            variantClick() {
                if (this.closeOnClick) {
                    this.closeDropdown();
                }
            },
            navigateToSearch() {
                if (this.type === 'global') {
                    var targetRoute = { name: 'ShopOverview', query: { search: this.search, 'addBranchFilter': false } };
                    if (this.$router.currentRoute.name === targetRoute.name)
                    {
                        // Force a hard reload (not using .go because FF won't hard refresh)
                        window.location = this.$router.resolve(targetRoute).href;
                    } else {
                        this.$router.push(targetRoute);
                        this.search = '';
                    }
                }
            },
            getSuggestions: _.debounce(function () {
                if (String(this.search).length >= 3) {
                  this.loading = true;
                  this.$store.dispatch('getProductsByTerm', {
                    params: {
                      search: this.search,
                      marketingOnly: this.marketingOnly,
                      includePre: this.includePreOrderProducts,
                      preOrderSheetId: this.preorderSheetId,
                      addBranchFilter: this.addBranchFilter,
                      branchRestriction: this.branchRestriction
                    }
                  }).then((products) => {
                    this.suggestions = products;
                    this.loading = false;
                  });
                }
            }, 300)
        }
    }
</script>

<style lang="scss">

    @import "~@/assets/scss/private";

    .c-customer-search {
        flex: 0 1 700px;

        &.is-open {
            .c-input {
                @include focus();
            }
        }
    }

    .c-product-search__input {
        width: 100%;
    }

    .c-product-search-dropdown {
        margin: 0;
        list-style: none;
        background-color: white;
        position: absolute;
        z-index: 100;
        top: calc(100% + 3px);
        width: 100%;
        box-shadow: 0 0 0 3px $color-neutral, 0 0 30px 0 rgba($color-base, .1);
        padding: em($global-spacing-unit);
        max-height: 400px;
        overflow-y: auto;

        &.no-group {
            padding: em($global-spacing-unit-small);
        }
    }

    .c-product-search-line {
        &:not(:last-child) {
            margin-bottom: em($global-spacing-unit-tiny);
        }
    }

    .c-product-search-line--group {
        &.has-variants {
            margin-bottom: em($global-spacing-unit) !important;
        }
    }

    .c-product-search-item__name {
        margin-top: .25em;
        width: 85%;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        cursor: default;
    }

    .c-product-search__item {
        display: flex;
        flex-wrap: wrap;
        align-items: flex-start;
        justify-content: space-between;
        background-color: white;
        padding: em($global-spacing-unit-tiny);
        padding-left: em($global-spacing-unit-small);

        > * {
            &:not(:last-child) {
                margin-right: em($global-spacing-unit-small);
            }
        }
    }

    .c-product-search__item--group {
        position: sticky;
        z-index: 1;
        top: em(-$global-spacing-unit);
        background-color: palette(color-neutral, x-light);

        .no-group & {
            @include rfs($font-size-small, true);
        }
    }

    .c-product-search__item--variant {
        box-shadow: 0 0 0 1px palette(color-neutral, light);

        .no-group & {
            &:hover {
                background-color: lighten($color-neutral, 30%);
                cursor: pointer;
                .c-product-search-item__name { cursor: pointer; }
            }
        }
    }

    .c-product-search-results-list {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    .c-product-search-variants-list {
        margin: 0;
        margin-top: em($global-spacing-unit-tiny);
        margin-left: em($global-spacing-unit);
        list-style: none;
        padding: 0;

        .no-group & {
            margin-left: em($global-spacing-unit-small);
        }
    }

    .c-product-search__loader {
        position: absolute;
        right: em($global-spacing-unit-small);
        top: 50%;
        transform: translateY(-50%);

        &.loading-enter-active, &.loading-leave-active {
            transition: .3s;
        }

        &.loading-leave-to {
            opacity: 0;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/form/productSearch/ProductSearch.vue